module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_13-233e837feb9a3fab972021c5be2af928.jpg";